import { Col, Row } from "@/components/customComponents";

import Pulse from "./Pulse";

const CARD_COUNT = 7;

const SummaryCardsSkeleton = () => (
  <Row className="flex-wrap gap-3">
    {Array.from({ length: CARD_COUNT }).map((slot, i) => (
      <Col
        key={i}
        className="min-w-[140px] flex-1 rounded-xl border border-default-200 border-l-4 border-l-default-300 bg-content1 p-3 shadow-sm dark:border-default-100 sm:min-w-[160px] sm:p-4"
      >
        <Pulse className="h-3 w-20" />
        <Pulse className="mt-2 h-6 w-16" />
        <Pulse className="mt-1 h-2.5 w-24" />
      </Col>
    ))}
  </Row>
);

export default SummaryCardsSkeleton;
